import { useEffect, useRef } from 'react'

/** 가로 스크롤 컨테이너에서 세로 휠을 가로 스크롤로 바꾼다.
 *  양 끝에 닿으면 가로채지 않으므로 페이지가 그대로 아래위로 스크롤된다 —
 *  캐러셀에 갇히지 않게 하는 게 핵심. */
export default function useWheelScroll<T extends HTMLElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const onWheel = (e: WheelEvent) => {
      const max = el.scrollWidth - el.clientWidth
      if (max <= 0) return // 넓은 화면 = 캐러셀 아님
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return // 이미 가로 제스처면 브라우저에 맡김

      // 끝에 닿았으면 넘겨준다
      if (e.deltaY < 0 && el.scrollLeft <= 0) return
      if (e.deltaY > 0 && el.scrollLeft >= max - 1) return

      e.preventDefault()
      el.scrollLeft += e.deltaY
    }

    // preventDefault를 쓰려면 passive: false 여야 한다
    el.addEventListener('wheel', onWheel, { passive: false })
    return () => el.removeEventListener('wheel', onWheel)
  }, [])

  return ref
}
